export default {
	annotation: {
		backToList: '返回列表',
		edit: '编辑标注',
		save: '保存标注',
		dragTip: '点击画布添加标注点，拖拽可调整位置',
		noDeviceId: '未找到设备 ID',
		defaultDeviceName: '未知设备',
		loadFailed: '加载失败',
		atLeastOnePoint: '请至少添加一个标注点',
		pointAdded: '已添加标注点',
		pointDeleted: '已删除标注点',
		saveSuccess: '保存成功',
		saveFallback: '保存失败，已保存到本地缓存',
		annotationPoint: '标注点',
		imageLoadFailed: '图片加载失败',
		editModeStarted: '编辑模式已启动',
		bindDevice: '绑定设备',
		noDeviceAvailable: '暂无可用设备',
		fetchDeviceListFailed: '获取设备列表失败',
		noDeviceAvailableForBind: '暂无可用设备',
		deviceBound: '设备绑定成功',
		close: '关闭',
		device: '设备{deviceId}'
	}
}
